import { useCallback, useEffect, useState } from 'react'

function normalize(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, '').toLowerCase()
  return trimmed === '' ? '/' : trimmed
}

/**
 * Minimal path-based routing so pages can be shared as real URLs,
 * e.g. www.topnotchbakery.se/events
 */
export function usePath() {
  const [path, setPath] = useState<string>(() =>
    typeof window === 'undefined' ? '/' : normalize(window.location.pathname),
  )

  useEffect(() => {
    const onPopState = () => setPath(normalize(window.location.pathname))
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  const navigate = useCallback((to: string) => {
    if (normalize(window.location.pathname) !== normalize(to)) {
      window.history.pushState({}, '', to)
    }
    setPath(normalize(to))
    window.scrollTo({ top: 0 })
  }, [])

  return { path, navigate }
}
